import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Button from '../button/Button';
import { hideModal } from '../../redux/actions';
import text from '../../text';
export var DEMO_PROJECT_ACTION_MODAL = 'DEMO_PROJECT_ACTION_MODAL';
var DemoProjectActionsModal = function(param) {
    var show = param.show;
    var dispatch = useDispatch();
    var onHide = function() {
        dispatch(hideModal(DEMO_PROJECT_ACTION_MODAL));
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        show: show,
        onHide: onHide,
        centered: true
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered",
        closeButton: true
    }, /*#__PURE__*/ React.createElement("h3", null, text('demoProjectOnly'))), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "centered"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", {
        className: "m-0"
    }, text('demoActionMessagePart1')), /*#__PURE__*/ React.createElement("p", {
        className: "mx-3"
    }, text('demoActionMessagePart2')), /*#__PURE__*/ React.createElement(Button, {
        variant: "link",
        className: "w-100",
        onClick: function() {
            return onHide();
        }
    }, /*#__PURE__*/ React.createElement("h5", null, text('closeAndContinue'))))));
};
export default DemoProjectActionsModal;
